import React, { useEffect, useState } from 'react'
import { faPencil, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';
import { useApiStore } from '../../hooks/ApiStoreContext';
import Swal from 'sweetalert2';

function Product() {
  DataTable.use(DT);
  const apiStore = useApiStore();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getProductList();
  }, [])

  const getProductList = async () => {
    try {
      const response = await apiStore.get("/product");
      //console.log(response);
      setTableData(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching products!", error);
      }
    }
  };


  const handleAddProduct = (e) => {
    e.preventDefault();
    navigate('/add-product');
  }

  const handleEdit = (e, id) => {
    e.preventDefault();
    //console.log(id);
    navigate('/add-product/' + id);
  }

  const handleDelete = async (e, id) => {
    e.preventDefault();
    //console.log(id);

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await apiStore.delete(`/product/${id}`);
        await Swal.fire("Deleted!", "Product deleted successfully.", "success");
        getProductList();
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error deleting the product!", error);
          Swal.fire("Error!", "There was an error deleting the product.", "error");
        }
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Cancelled", "Your product is safe :)", "info");
    }
  }

  const handleStatus = async (e, data, row) => {
    try {
      const submitData = {
        productId: row.productId,
        name: row.name,
        code: row.code,
        categoryId: row.categoryId,
        price: row.price,
        gstIncluded: row.gstIncluded,
        gst: row.gst,
        gstAmount: row.gstAmount,
        basePrice: row.basePrice,
        discount: row.discount,
        discountAmount: row.discountAmount,
        priceAfterDiscount: row.priceAfterDiscount,
        gstAmountAfterDiscount: row.gstAmountAfterDiscount,
        totalPrice: row.totalPrice,
        stock: row.stock,
        hsnCode: row.hsnCode,
        isActive: !data,
        description: row.description,
        moq: row.moq,
        moqQuantity: row.moqQuantity,
        gender: row.gender,
        ageGroup: row.ageGroup,
        fabric: row.fabric,
        color: row.color,
        occasion: row.occasion,
        size: row.size,
        pattern: row.pattern,
        setContent: row.setContent,
        designNumber: row.designNumber,
        rateOfPiece: row.rateOfPiece,
        productImages: row.productImages,
        updatedDate: new Date(),
      };
      await apiStore.put(`/product/${row.productId}`, submitData);
      getProductList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the product status!", error);
      }
    }

  }

  return (
    <Row>
      <Col md={12}>
        <Card className='mb-4'>
          <CardHeader className='pb-0'>
            <Row>
              <Col md={9}>
                <h4>Product List</h4>
              </Col>
              <Col md={3} className='d-grid d-md-flex justify-content-md-end d-sm-block'>
                <Button variant='outline-primary' className='btn-sm' onClick={handleAddProduct}>Add product</Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className='px-0 pt-0 pb-2'>

            <div className='mx-3'>
              <DataTable className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: 'name', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'code', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'category', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'price', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'isActive', className: 'text-sm font-weight-bold align-middle text-center' },
                    { data: 'productId', className: 'text-secondary text-sm font-weight-bold align-middle text-center' },
                  ],
                }}
                slots={{
                  2: (data, row) => {
                    return (
                      <React.Fragment>
                        {/* <span className={data.toLowerCase() == 'active' ? 'badge badge-sm cursor-pointer bg-gradient-success' : 'badge badge-sm cursor-pointer bg-gradient-danger'} onClick={(e) => handleStatus(e, data, row)}>{data}</span> */}
                        <span >
                          {data.name}
                        </span>
                      </React.Fragment>
                    )
                  },
                  4: (data, row) => {
                    return (
                      <React.Fragment>
                        {/* <span className={data.toLowerCase() == 'active' ? 'badge badge-sm cursor-pointer bg-gradient-success' : 'badge badge-sm cursor-pointer bg-gradient-danger'} onClick={(e) => handleStatus(e, data, row)}>{data}</span> */}
                        <span className={data ? "badge badge-sm cursor-pointer bg-gradient-success" : "badge badge-sm cursor-pointer bg-gradient-danger"} onClick={(e) => handleStatus(e, data, row)}>
                          {data ? "Active" : "Inactive"}
                        </span>
                      </React.Fragment>
                    )
                  },
                  5: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className='me-3 cursor-pointer' title='Edit' onClick={(e) => handleEdit(e, data)} >
                          <FontAwesomeIcon icon={faPencil} size='lg'></FontAwesomeIcon>
                        </a>
                        <a className='text-danger cursor-pointer' title='Delete' onClick={(e) => handleDelete(e, data)} >
                          <FontAwesomeIcon icon={faTrashCan} size='lg'></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}
              >
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Code</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Category</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Price</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>

          </CardBody>

        </Card>
      </Col>
    </Row>
  )
}

export default Product